import moment from 'moment/moment'
import Vue from 'vue'


Vue.filter("euroFilter", str => str + 'â‚¬')
Vue.filter("currencyFilter", (n, showSign = false) => {
    const formatter = new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
        signDisplay: showSign ? 'always' : 'auto'
    })
    return  formatter.format(parseFloat(n))
})
Vue.filter("percentFilter", str => str + '%')
Vue.filter('formatDateFilter', str => moment.unix(str / 1000).format('DD.MM.YYYY HH:mm'))
Vue.filter('formatISODateFilter', str => moment(str,"YYYY-MM-DD").format('DD.MM.YYYY'))